<div class="undo-snackbar-body" matSnackBarLabel
     (mouseenter)="pause()" (mouseleave)="resume()"
     (focusin)="pause()" (focusout)="resume()">
    <span class="undo-message">{{data.message}}</span>
    <span class="undo-actions" matSnackBarActions>
        <button class="undo-action-btn"
                matSnackBarAction
                (click)="onUndo()">
            Undo
        </button>
        <button class="dismiss-btn"
                matSnackBarAction
                aria-label="Dismiss"
                (click)="onDismiss()">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
            </svg>
        </button>
    </span>
</div>
<mat-progress-bar
    class="countdown-bar"
    mode="determinate"
    [value]="progress()">
</mat-progress-bar>
